import React, { useEffect, useState } from 'react';
import { Input, Card, Button, List, Typography, Space, Tag, Empty } from 'antd';
import { CheckCircleFilled, ExperimentOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';
import Spinner from '../spinner/Spinner';
import './ResetTestgroupStep2.scss';

const { Title, Text } = Typography;
const { Search } = Input;

const ResetTestgroupStep2 = ({
  fetchCompanySearches,
  selectedCompany,
  selectedSearch,
  companySearches,
  loading,
  handleSelectSearch,
  handleNextStep,
  handlePreviousStep,
}) => {
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchCompanySearches({ companyId: selectedCompany, search });
  }, []);

  return (
    <div className="reset-step-container modern-step">
      <div className="step-header">
        <Title level={3} className="step-title">
          <ExperimentOutlined className="step-icon" />
          {t('RESET_TESTGROUP_STEP_2_TITLE')}
        </Title>
      </div>

      <div className="step-content">
        <div className="search-section">
          <Search
            placeholder={t('RESET_TESTGROUP_STEP_2_SEARCH_PLACEHOLDER')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={(value) => fetchCompanySearches({ companyId: selectedCompany, search: value })}
            className="modern-search"
            size="large"
          />
        </div>

        <div className="evaluations-selection-area">
          {loading ? (
            <div className="loading-container">
              <Spinner show />
            </div>
          ) : companySearches?.collection?.length > 0 ? (
            <List
              className="evaluations-list"
              dataSource={companySearches.collection}
              renderItem={(evaluation) => (
                <List.Item className="evaluation-item">
                  <Card
                    hoverable
                    onClick={() => handleSelectSearch(evaluation)}
                    className={`evaluation-card ${selectedSearch?.id === evaluation.id ? 'selected-card' : ''}`}
                    size="small"
                  >
                    <div className="evaluation-content">
                      <Space className="w-100 justify-content-between align-items-center">
                        <div className="evaluation-info">
                          <Text strong className="evaluation-name">{evaluation.name}</Text>
                        </div>
                        {selectedSearch?.id === evaluation.id && (
                          <CheckCircleFilled className="check-icon-evaluation" />
                        )}
                      </Space>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          ) : (
            <Empty
              description={t('RESET_TESTGROUP_STEP_2_EMPTY_STATE_TITLE')}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              className="empty-state"
            />
          )}
        </div>
      </div>

      <div className="step-footer">
        <Space>
          <Button onClick={handlePreviousStep} className="back-btn" size="large">
            {t('RESET_TESTGROUP_BACK_BUTTON')}
          </Button>
          <Button
            type="primary"
            onClick={handleNextStep}
            disabled={!selectedSearch}
            className="next-step-btn"
            size="large"
          >
            {t('RESET_TESTGROUP_NEXT_BUTTON')}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default ResetTestgroupStep2;
